import { Stack, Text } from '@chakra-ui/react';

import { LinkComponent } from '@/modules/navigation';

type Link = {
	href:     string;
	label:    string;
	isNewTab: boolean;
};

type FooterLinkColumnProps = {
	heading: string;
	links:   Link[];
};

const FooterLinkColumn = ({ heading, links }: FooterLinkColumnProps) => {
	return (
		<Stack gap={4}>
			<Text as={'h3'} textStyle={'s5'}>{heading}</Text>
			<Stack gap={2}>
				{links.map(link => (
					<LinkComponent key={link.href} href={link.href} isNewTab={link.isNewTab}>
						{link.label}
					</LinkComponent>
				))}
			</Stack>
		</Stack>
	);
};

export default FooterLinkColumn;
